import { Alert, Button, Col, Input, Radio, RadioChangeEvent, Row, Skeleton, Space, Tooltip, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
// import { useRecoilState } from "recoil";
// import { memberState } from "../../../state/atoms";
import "../PrintCheckoutPage";
import { Summary } from "./Summary";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PrintApi from "../../../api/PrintApi";
import { StripeForm } from "./StripeForm";
import OrdersApi from "../../../api/OrdersApi";
import { useRecoilState, useRecoilValue } from "recoil";
import { memberState, mobileState } from "../../../state/atoms";
import { env } from "../../../env/env";
import { CloseOutlined, CreditCardOutlined, DownOutlined, FileDoneOutlined, UpOutlined } from "@ant-design/icons";
import { OrderStatusEnum } from "../../../generated/print-client";
import { logCheckout } from "../../../service/AnalyticsService";
import { STRIPE_DEFAULT_SETTINGS } from "../../../util/constants";
import TeamsApi from "../../../api/TeamsApi";

const stripePromise = loadStripe(env.stripeKey);

export function Payment({ order, setOrder, view, setView, setCartCount, checkoutMessage }: any) {
  const [loading, setLoading] = useState(false);
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false);
  const [loadingClientSecret, setLoadingClientSecret] = useState(false);
  const [loadingApplyCoupon, setLoadingApplyCoupon] = useState(false);
  const [creatingPaymentIntent, setCreatingPaymentIntent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [haveACoupon, setHaveACoupon] = useState(false);

  const [member] = useRecoilState(memberState);
  const [total] = useState(order.total.toFixed(2).toString().replace('.', ''));

  const [clientSecret, setClientSecret] = useState('');
  // const [message, setMessage] = useState('');
  const [options, setOptions] = useState({});
  const mobile = useRecoilValue(mobileState);

  const [paymentMethods, setPaymentMethods] = useState([] as any[]);
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState("" as any);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("" as any);

  const [errorMessage, setErrorMessage] = useState('');
  const [couponErrorMessage, setCouponErrorMessage] = useState('');

  useEffect(() => {
    setLoadingPaymentMethods(true);

    PrintApi.getPaymentMethods(member.email, member.internalId).then(resp => {
      const data = (resp.data as any).data

      if (data && data.length > 0) {
        setPaymentMethods(data)
        // setSelectedPaymentMethod(data[0].id)
      }

      PrintApi.getDefaultPaymentMethod(member.email, member.internalId).then(resp2 => {
        const data = (resp2.data as any)

        if (data) {
          setDefaultPaymentMethod(data)
          setSelectedPaymentMethod(data)
        }

        setLoadingPaymentMethods(false);
      });
    });
  }, [setSelectedPaymentMethod, member]);

  const createPaymentIntent = useCallback((params: any) => {
    PrintApi.createPaymentIntent(JSON.stringify(params)).then(resp => {
      const paymentIntent = resp.data as any
      const secret = paymentIntent['client_secret'];

      startStripeOptions(secret)

      order.paymentIntent = JSON.stringify(paymentIntent)

      OrdersApi.updateOrder(order).then((resp) => {
        setOrder(resp.data);
        setCreatingPaymentIntent(false);
        setLoadingClientSecret(false);
      }).catch((err) => {
        console.log(err);
      });
    })
  }, [order, setOrder]);

  useEffect(() => {
    if (!clientSecret) {
      const paymentIntentFromUrl = new URLSearchParams(window.location.search).get("payment_intent");

      // if (false) {
      if (order.paymentIntent && order.status === OrderStatusEnum.Draft && !paymentIntentFromUrl) {
        let paymentIntent = JSON.parse(order.paymentIntent)
        const secret = paymentIntent['client_secret'];

        setCreatingPaymentIntent(true);
        setLoadingClientSecret(true);

        let params = {
          paymentIntentId: paymentIntent.id,
          amount: total,
        }

        PrintApi.updatePaymentIntent(JSON.stringify(params)).then(resp => {
          paymentIntent = resp.data as any

          startStripeOptions(secret)

          order.paymentIntent = JSON.stringify(paymentIntent)

          OrdersApi.updateOrder(order).then((resp) => {
            setOrder(resp.data);
            setCreatingPaymentIntent(false);
            setLoadingClientSecret(false);
          }).catch((err) => {
            console.log(err);
          });
        })
      } else {
        if (!creatingPaymentIntent) {
          setCreatingPaymentIntent(true);
          setLoadingClientSecret(true);

          let params = {
            amount: total,
            email: member.email,
            memberId: member.internalId.toString(),
            name: order.name,
            orderId: order.id
          }

          if (!member.owner) {
            TeamsApi.getTeamOwner(member.teamId).then((resp) => {
              const owner = resp.data;

              params.email = owner?.email!!;
              params.memberId = owner?.internalId!!.toString();

              createPaymentIntent(params);
            }).catch((ex) => {
            });
          } else {
            createPaymentIntent(params);
          }
        }
      }
    } else {
      setLoadingClientSecret(false);
    }
  }, [creatingPaymentIntent, clientSecret, total, order, setOrder, member, createPaymentIntent]);

  function startStripeOptions(secret: string) {
    setClientSecret(secret);
    setOptions({
      clientSecret: secret,
      ...STRIPE_DEFAULT_SETTINGS
    });
  }

  function onChangePaymentMethod(ev: RadioChangeEvent) {
    setSelectedPaymentMethod(ev.target.value);
    setErrorMessage('');
  }

  function onReturnClick() {
    setView("shipping");
  }

  function beforeUnloadFunc(e: any) {
    e.preventDefault();
    e.returnValue = "";
  }

  function submitOrderManually() {
    setSubmitting(true);
    setErrorMessage('');

    let paymentIntent = JSON.parse(order.paymentIntent)

    if (selectedPaymentMethod === "invoice") {
      order.invoicePayment = true;
      submitOrder();
    } else {
      PrintApi.submitPaymentIntent(paymentIntent.id, selectedPaymentMethod).then(resp => {
        console.log(resp);

        paymentIntent = resp.data as any

        var action = paymentIntent.next_action;
        if (action) {
          if (action.type === 'redirect_to_url') {
            window.location = action.redirect_to_url.url;
          } else if (action.type === 'use_stripe_sdk') {
            window.location = action.use_stripe_sdk.stripe_js;
          }
        } else {
          if (paymentIntent.status === 'succeeded') {
            submitOrder();
          } else {
            setSubmitting(false);
            setLoading(false);
            setErrorMessage(resp.data as string);
          }
        }
      })
    }
  }

  const submitOrder = useCallback(() => {
    setSubmitting(true);

    if (order.coupon) {
      PrintApi.saveUsedCoupon(order.coupon, member.internalId)
    }

    OrdersApi.submitOrder(order)
      .then((resp2) => {
        console.log(resp2);
        logCheckout(resp2.data);
        setSubmitting(false);
        setCartCount(0);
        setView("success");
        window.removeEventListener("beforeunload", beforeUnloadFunc);
      })
      .catch((err) => {
        OrdersApi.submitOrder(order)
          .then((resp2) => {
            console.log(resp2);
            logCheckout(resp2.data);
            setSubmitting(false);
            setCartCount(0);
            setView("success");
            window.removeEventListener("beforeunload", beforeUnloadFunc);
          })
          .catch((err) => {
            const errorMsg = "There was an error while placing your order. \nPlease contact us at support@musthavemenus.com"
            alert(errorMsg);
            setErrorMessage(errorMsg);

            setSubmitting(false);
            console.log(err);
            window.removeEventListener("beforeunload", beforeUnloadFunc);
          });
      });
  }, [order, setCartCount, setView, member.internalId])

  useEffect(() => {
    const paymentIntentFromUrl = new URLSearchParams(window.location.search).get("payment_intent");

    if (!paymentIntentFromUrl) {
      return;
    } else {

      setLoading(true);

      let params = {
        paymentIntentId: paymentIntentFromUrl,
      }

      PrintApi.getPaymentIntent(JSON.stringify(params)).then(resp => {
        let paymentIntent = resp.data as any
        switch (paymentIntent!.status) {
          case "succeeded":
            order.paymentIntent = JSON.stringify(paymentIntent)
            submitOrder();
            break;
          case "processing":
          case "requires_payment_method":
          default:
            setLoading(false);
            break;
        }
      });
    }
  }, [setLoading, order, submitOrder]);

  function updatePaymentIntentAmount(amount: number) {
    let paymentIntent = JSON.parse(order.paymentIntent)

    let params = {
      paymentIntentId: paymentIntent.id,
      amount: amount.toFixed(2).toString().replace('.', ''),
    }

    PrintApi.updatePaymentIntent(JSON.stringify(params)).then(resp => {
      paymentIntent = resp.data as any
      order.paymentIntent = JSON.stringify(paymentIntent)

      OrdersApi.updateOrder(order).then((resp) => {
        setOrder(resp.data);
      }).catch((err) => {
        console.log(err);
      });
    })
  }

  function onChangeCoupon(e: any) {
    setCoupon(e.target.value.trim());
  }

  function applyCoupon() {
    if (!coupon) return;

    let paymentIntent = JSON.parse(order.paymentIntent)

    let params = {
      paymentIntentId: paymentIntent.id,
      coupon: coupon,
      subtotal: order.subtotal,
      memberId: member.internalId,
      remove: false
    }

    setLoadingApplyCoupon(true);
    setCouponErrorMessage("");

    PrintApi.applyCoupon(JSON.stringify(params)).then(resp => {
      console.log(resp.data)
      const response = resp.data as any;

      if (response.error) {
        setCouponErrorMessage(response.error);
        setLoadingApplyCoupon(false);
      } else {
        order.paymentIntent = JSON.stringify(JSON.parse(response.paymentIntent));
        order.discount = response.discount
        order.coupon = coupon;

        OrdersApi.updateOrder(order).then((resp) => {
          setOrder(resp.data);
          updatePaymentIntentAmount(resp.data.total!);
          setLoadingApplyCoupon(false);
        }).catch((err) => {
          console.log(err);
        });
      }
    })
  }

  function removeCoupon() {
    let paymentIntent = JSON.parse(order.paymentIntent)

    let originalAmount = order.total + order.discount;

    let params = {
      paymentIntentId: paymentIntent.id,
      coupon: order.coupon,
      originalAmount: originalAmount,
      memberId: member.internalId,
      remove: true
    }

    setLoadingApplyCoupon(true);

    PrintApi.applyCoupon(JSON.stringify(params)).then(resp => {
      console.log(resp.data)
      const response = resp.data as any;
      order.paymentIntent = JSON.stringify(JSON.parse(response.paymentIntent));
      order.discount = 0;
      order.coupon = "";

      OrdersApi.updateOrder(order).then((resp) => {
        setOrder(resp.data);
        updatePaymentIntentAmount(resp.data.total!);
        setLoadingApplyCoupon(false);
      }).catch((err) => {
        console.log(err);
      });
    })
  }

  return (
    <div className={"print-payment-page"}>
      <Row>
        <Col span={12} className={`payment-section`}>
          <div className="payment">
            {!mobile && <h3>Payment</h3>}
            {mobile && <h3>Payment & Review</h3>}

            {loadingPaymentMethods && <Skeleton />}

            {!loadingPaymentMethods &&
              <>
                <h5>Payment Method</h5>

                {(member.printInvoicing || (paymentMethods && paymentMethods.length > 0 && defaultPaymentMethod)) &&
                  <Radio.Group value={selectedPaymentMethod} onChange={onChangePaymentMethod}>
                    <Space direction="vertical">
                      {paymentMethods && paymentMethods.length > 0 && defaultPaymentMethod &&
                        <>
                          {paymentMethods.map((paymentMethod) => {
                            if (paymentMethod.id === defaultPaymentMethod) {
                              return <Radio value={paymentMethod.id} key={paymentMethod.id}>
                                <Space style={{ border: "1px solid #e6e6e6", padding: "5px 10px 5px 10px", borderRadius: 5 }}>
                                  <CreditCardOutlined />
                                  <span>{paymentMethod.card.brand.toUpperCase()} •••• {paymentMethod.card.last4}</span>
                                </Space>
                              </Radio>
                            }
                            return <></>
                          })}
                        </>
                      }

                      <Radio value={""}>
                        <Space>
                          <CreditCardOutlined />
                          New credit or debit card
                        </Space>
                      </Radio>

                      {member.printInvoicing &&
                        <Radio value={"invoice"}>
                          <Space>
                            <FileDoneOutlined />
                            Invoice
                          </Space>
                        </Radio>
                      }
                    </Space>
                  </Radio.Group>
                }

                {/* {paymentMethods && paymentMethods.length > 0 &&
                  <Radio.Group value={selectedPaymentMethod} onChange={onChangePaymentMethod} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      {paymentMethods.map((paymentMethod) => (
                        <Radio value={paymentMethod.id} key={paymentMethod.id}>
                          <Space style={{ border: "1px solid #e6e6e6", padding: "5px 10px 5px 10px", borderRadius: 5 }}>
                            <CreditCardOutlined />
                            <span>{paymentMethod.card.brand.toUpperCase()} **** **** **** {paymentMethod.card.last4} ({paymentMethod.card.exp_month}/{paymentMethod.card.exp_year})</span>
                          </Space>
                        </Radio>
                      ))}
                      <Radio value={""}>New credit or debit card</Radio>
                    </Space>
                  </Radio.Group>
                } */}

                <Typography.Paragraph>
                  {errorMessage && <Alert
                    message={errorMessage}
                    description="Please check your payment data."
                    type="error"
                    showIcon
                  />}
                </Typography.Paragraph>

                {selectedPaymentMethod === "invoice" &&
                  <Space direction="vertical" align="center" style={{ display: "block", alignItems: "center", textAlign: "center", padding: "15px" }}>
                    <FileDoneOutlined style={{ fontSize: 60, color: "#999999", marginBottom: 15 }} />
                    <p style={{ fontSize: 18, lineHeight: "20px" }}>An invoice will be issued for this order<br /> per your agreement</p>
                  </Space>
                }

                <Space direction="vertical" className="coupon-wrapper">
                  <h5 onClick={() => setHaveACoupon(!haveACoupon)}>Enter promo code {haveACoupon || order.coupon ? <UpOutlined /> : <DownOutlined />}</h5>

                  {(haveACoupon || order.coupon) &&
                    <>
                      {!order.coupon ?
                        <Space direction="vertical">
                          <Space>
                            <Input style={{ width: 210 }} placeholder="Enter promo code here" value={coupon} onChange={onChangeCoupon} />
                            <Button onClick={applyCoupon} type="link" loading={loadingApplyCoupon}>Apply coupon</Button>
                          </Space>

                          {couponErrorMessage &&
                            <Typography.Paragraph>
                              <Alert
                                message={couponErrorMessage}
                                type="error"
                                showIcon
                              />
                            </Typography.Paragraph>
                          }
                        </Space>
                        :
                        <Space>
                          Coupon:
                          <b>{order.coupon}</b>
                          <Button size="small" onClick={removeCoupon} type="link" loading={loadingApplyCoupon}>
                            <Tooltip title="Remove coupon">
                              <CloseOutlined />
                            </Tooltip>
                          </Button>
                        </Space>
                      }
                    </>
                  }
                </Space>

                {selectedPaymentMethod &&
                  <Space className={"footer-btns"} direction="vertical" style={{ width: '100%' }}>
                    <Button type="primary" size="large" block loading={submitting} onClick={submitOrderManually}>
                      Submit Order
                    </Button>

                    <Button className={"return-to-previous"} type="text" block onClick={onReturnClick}>
                      &lt; Return to Shipping
                    </Button>
                  </Space>
                }
              </>
            }

            <Skeleton loading={loadingClientSecret && !selectedPaymentMethod} style={{ marginTop: 20 }} />

            {!loadingClientSecret && clientSecret && !selectedPaymentMethod && selectedPaymentMethod !== "invoice" &&
              <Elements stripe={stripePromise} options={options}>
                <StripeForm
                  setLoading={setLoading}
                  loading={loading}
                  setView={setView}
                  order={order}
                  setOrder={setOrder}
                  setCartCount={setCartCount}
                  member={member} />
              </Elements>
            }

            <Summary order={order} view={view} isMobile={mobile} checkoutMessage={checkoutMessage} />
          </div>
        </Col>

        <Col span={12} className={`desktop-summary`}>
          <Summary order={order} view={view} isComputingTax={loadingApplyCoupon} checkoutMessage={checkoutMessage} />
        </Col>
      </Row>
    </div>
  );
}
